<template>
    <div class="coupon-popup" :class="{ 'coupon-popup--active': value }" v-if="value" @click.self="onClose">
        <div class="coupon-popup__wrap">
            <div class="coupon-popup__wrap--title">
                <div class="coupon-popup__title--text">优惠券</div>
                <div class="coupon-popup__title--close" @click="onClose"></div>
            </div>
            <div class="coupon-popup__wrap--contain">
                <div class="coupon-yet" v-if="list.length <= 0">暂无优惠券</div>
                <coupon-item v-else v-for="item in list"
                             :key="item.id"
                             :coupon="item"
                             :currentCoupon="currentCoupon"
                             @on-click="handleCouponClick"></coupon-item>
            </div>
        </div>
    </div>
</template>

<script>
    import {expirationtime} from "../../../utils/date";

    export default {
        name: 'CouponPopup',
        props: {
            value: Boolean,
            list: Array,
            currentCoupon: String,
            totalFee: Number,
            item: Object,
        },
        components: {
            CouponItem: () => import('./CouponItem')
        },
        methods: {
            onClose() {
                this.$emit('input', !this.value);
            },
            handleCouponClick(coupon) {
                this.$emit('on-click', coupon);

            }
        }
    };
</script>

<style scoped lang="scss">
    .coupon-popup {
        position: fixed;
        top: 0;
        bottom: -100%;
        left: 0;
        right: 0;
        transition: all 300ms;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 999;

        &--active {
            bottom: 0;
        }

        &__wrap {
            position: absolute;
            bottom: 0;
            height: 75%;
            left: 0.27rem;
            right: 0.27rem;
            background-color: #e5e5e5;
        }
    }

    .coupon-popup__wrap {
        display: flex;
        flex-direction: column;
        align-items: center;

        &--title {
            width: 100%;
            line-height: 1.07rem;
            background-color: #fff;
            text-align: center;
            position: relative;
            color: #4f4f4f;
            font-size: 0.4rem;

            .coupon-popup__title--close {
                position: absolute;
                right: 0.3rem;
                top: 50%;
                transform: translateY(-50%);
                background: url('../../../assets/icon-close.png') center / 100% no-repeat;
                width: 0.4rem;
                height: 0.4rem;
            }
        }

        &--contain {
            width: 100%;
            flex: 1;
            overflow: scroll;
        }
    }

    .coupon-yet {
        font-size: 0.4rem;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(143, 143, 143, 1);
        text-align: center;
        padding-top: 5.59rem;
        letter-spacing: 0.08rem;
    }
</style>
